'use strict'

var Marionette = require('marionette')
var App = require('app')
var TabBehavior = require('src/behaviors/tabs')
var PageComponent = require('src/components/page-view')

// var itemView = module.exports.item = Marionette.CompositeView.extend({
//   tagName: 'tr',
//   className: 'm-list-row',
//   template: require('./templates/item.html'),
//   triggers: {
//     'click .js-edit': 'device:edit',
//     'click .js-control': 'device:control',
//     'click .js-delete': 'device:delete',
//     'click': 'device:show'
//   },
//   templateContext: function () {
//     return {
//       getConditionalStr: App.TemplateHelpers.getConditionalStr,
//       getDeviceTypeLabel: App.TemplateHelpers.getDeviceTypeLabel
//     }
//   },
//   modelEvents: {
//     'change': 'render'
//   }
// })
// module.exports.itemView = itemView

// var listView = Marionette.CompositeView.extend({
//   template: require('./templates/list.html'),
//   className: 'page page__devices',

//   childView: itemView,
//   childViewContainer: 'tbody',
//   triggers: {
//     'click .js-add': 'client:add'
//   }

// })
// var itemView = module.exports.item = Marionette.CompositeView.extend({
//  template: require('./templates/report-list.html')
// })
var Pikaday = require('pikaday')
var Moment = require('moment')

/*
var picker = new Pikaday(
   {
       field: document.getElementById('datepicker'),
       firstDay: 1,
       minDate: new Date(2000, 0, 1),
       maxDate: new Date(2020, 12, 31),
       yearRange: [2000, 2020],
       bound: false,
       container: document.getElementById('container'),
   })

 */

// js-period-picker
// -- Reports Data --
var ReportsDataLayout = Marionette.View.extend({
  template: require('./templates/report-data-layout.html'),
  events: {
    'click .js-report-period-field': 'onPeriodFieldClick',
    'click .js-report-period-apply': 'onPeriodApply',
    'change .js-report-resolution-select': 'onResolutionChange',
    'click .js-export': 'onExport'
  },
  modelEvents: {
    'change': 'render'
  },
  onExport: function (args) {
    this.triggerMethod('report:export', this)
  },
  templateContext: function () {
    var self = this
    return {
      hasResults: function () {

        if (!this.data) return false
        if (_.size(this.data) <= 0) return false
        return true
      },
      formatTime: function(time) {
        let resolution = self.model.get('resolution');
        let format

        switch(resolution) {
          case 'day':
          case 'week':
          case 'month':
          format = 'DD MMM YYYY'
          break;
        }

        return App.TemplateHelpers.formatTime(time, format)

      },
      //formatTime: App.TemplateHelpers.formatTime,
      formatValue: function (value, decimals = 2) {
        let formattedValue = parseFloat(value).toFixed(decimals)
        if (isNaN(formattedValue)) formattedValue = '-'
        return formattedValue
      }
    }
  },
  onUpdateStartDate: function (date) {
    var date = this.startPicker.getDate()
    this.startPicker.setStartRange(date)
    this.endPicker.setStartRange(date)
    this.endPicker.setMinDate(date)
    this.endPicker.draw()
    this.startPicker.draw()

  // console.log('update start date')
  },
  onUpdateEndDate: function (date) {
    var date = this.endPicker.getDate()

    this.startPicker.setEndRange(date)
    this.startPicker.setMaxDate(date)
    this.endPicker.setEndRange(date)
    this.startPicker.draw()
    this.endPicker.draw()
  },
  onResolutionChange: function (ev) {
    this.model.set('resolution', ev.target.value)
    this.trigger('report:refresh', this)
  },
  onUpdateField: function () {
    var start = Moment(this.startPicker.getDate())
    var end = Moment(this.endPicker.getDate())
    this.periodField.value = start.format('MMM D, YYYY') + ' - ' + end.format('MMM D, YYYY')
  },
  renderPeriodSelector: function () {
    var self = this

    var reportsStartPicker = this.el.querySelector('.js-reports-range-start')
    var reportsEndPicker = this.el.querySelector('.js-reports-range-end')

    var startDate
    var endDate

    this.startPicker = new Pikaday({
      field: this.el.querySelector('.js-period-input-start'),
      minDate: new Date(2016, 0, 1),
      maxDate: Moment().subtract(1, 'day').toDate(),
      defaultDate: Moment(self.model.get('startDate')).toDate(),
      setDefaultDate: true,
      bound: false,
      container: reportsStartPicker,
      onSelect: function () {
        startDate = this.getDate()
        self.onUpdateStartDate(startDate)
        self.onUpdateField()
      }
    })
    this.endPicker = new Pikaday({
      field: this.el.querySelector('.js-period-input-end'),
      minDate: new Date(2016, 0, 1),
      maxDate: Moment().subtract(1, 'day').toDate(),
      defaultDate: Moment(self.model.get('endDate')).toDate(),
      bound: false,
      setDefaultDate: true,
      container: reportsEndPicker,
      onSelect: function () {
        endDate = this.getDate()

        self.onUpdateEndDate(endDate)
        self.onUpdateField()
      }
    })
    var _startDate = self.startPicker.getDate()
    var _endDate = self.endPicker.getDate()
    if (_startDate) {
      startDate = _startDate
      self.onUpdateStartDate(startDate)
    }
    if (_endDate) {
      endDate = _endDate
      self.onUpdateEndDate(startDate)
    }
    self.onUpdateField()
  },
  onPeriodApply: function (ev) {
    this.periodPopup.classList.remove('is-visible')

    this.model.set({
      'startDate':Moment(this.startPicker.getDate()).format('YYYY-MM-DD'),
      'endDate':Moment(this.endPicker.getDate()).format('YYYY-MM-DD')
    })

    this.trigger('report:refresh', this)
  },
  onPeriodFieldClick: function () {
    this.periodPopup.classList.toggle('is-visible')
  },
  onRender: function () {
    var self = this
    self.periodField = self.el.querySelector('.js-report-period-field')
    self.periodPopup = self.el.querySelector('.js-report-period-popup')

    self.renderPeriodSelector()
  }

})
module.exports.ReportsDataLayout = ReportsDataLayout

// -- Reports List --
var reportsListItem = Marionette.View.extend({
  template: require('./templates/report-list-item.html'),
  tagName: 'li',
  modelEvents: {
    'change': 'render'
  },
  triggers: {
    'click': 'report:show'
  },
  // template: require('./templates/item.html')
})

var reportsListView = Marionette.CollectionView.extend({
  template: require('./templates/report-list.html'),
  childView: reportsListItem,
  tagName: 'ul',
  className: 'reports__list'
})

module.exports.ReportsListView = reportsListView

// -- Layout --
var Reports = Marionette.View.extend({
  template: require('./templates/layout.html'),
  triggers: {
  },
  regions: {
    reportsListRegion: '.reports-list__region',
    reportsDataRegion: '.reports-data__region'
  // contentRegion: '.body-region'
  },
  behaviors: {
  },
  initialize: function () {
    var self = this
    this.listenTo(this.collection, 'request', function () {
      self.el.classList.add('loading')
    })

    this.listenTo(this.collection, 'sync add remove', function () {
      setTimeout(function () {
        self.el.classList.remove('loading')
      }, 500)
      self.el.querySelector('.result-header__status .label').innerHTML = 'These reports are based on ' + this.collection.length + ' devices'
    })
  },
  onRender: function () {
    // var self = this
    // var reportView = new itemView()
    // self.contentRegion.show(reportView)
  }

})
module.exports.Reports = Reports

var PageComponent = require('src/components/page-view')

// module.exports.Layout = Layout
// -- Page Layout ---------------------------
//
var Layout = PageComponent.Layout.extend({
  className: 'page page-reports page-filter-layout'
})
module.exports.Layout = Layout



// WEBPACK FOOTER //
// ./js/modules/page-reports/list/view.js